import { render, staticRenderFns } from "./text-row.vue?vue&type=template&id=4fa506aa&scoped=true&"
import script from "./text-row.vue?vue&type=script&lang=js&"
export * from "./text-row.vue?vue&type=script&lang=js&"
import style0 from "./text-row.vue?vue&type=style&index=0&id=4fa506aa&scoped=true&lang=css&"
import style1 from "./text-row.vue?vue&type=style&index=1&id=4fa506aa&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa506aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa506aa')) {
      api.createRecord('4fa506aa', component.options)
    } else {
      api.reload('4fa506aa', component.options)
    }
    module.hot.accept("./text-row.vue?vue&type=template&id=4fa506aa&scoped=true&", function () {
      api.rerender('4fa506aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row.vue"
export default component.exports